import $ from "jquery";
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

import _createElementByParamInfo from "./_createElementByParamInfo";
import _createEmptyElementByParamInfo from "./_createEmptyElementByParamInfo";
import replace from "./replace";

vuwer.appendKlass("VuwReplicant", {
	_defaultOptions: {
		selector() {
			if(
				this.container.$self instanceof $ &&
				this.container.$self.length
			) {
				return this.createDefaultElement().appendTo(this.container.$self);
			}
		}
	},
	
	_createElementByParamInfo,
	_createEmptyElementByParamInfo,
	...replace,
	
	/**
	 * [コンストラクタ]
	 * @param {Object} opt
	 * @returns this
	 */
	_initialize(opt) {
		u_.isObject(opt) || (opt = {});
		opt = { ...this._defaultOptions, ...opt };
		
		// onReadyFirstが指定されている場合は退避
		if( u_.isFunction(opt.onReadyFirst) ) {
			this._onReadyFirst = opt.onReadyFirst;
			delete opt.onReadyFirst;
		}
		
		if( Klass("VuwReplicant").parent._initialize.call(this, opt) ) {
			if( !( this.container instanceof Klass("VuwColony") ) ) {
				csl.warn("VuwReplicant must be a child of VuwColony.");
				return false;
			}
			
			// set index
			this.index = parseInt( this.name.split("_").pop() );
			
			// default state
			this.state.is = "sleeping";
			
			// [unshift onChangeState callback]
			this._onChangeStateCallbacks.unshift(this._onChangeIs);
			
			// image promise list
			this.imagePromiseList = [];
			
			return this;
			
		} else {
			return false;
		}
	},
	
	/**
	 * 状態変化用関数
	 * @param {Object} state
	 */
	_onChangeIs(state) {
		if(this.$self && u_.isString(state.is) && state.is !== this.state.is) {
			this.$self.attr("data-is", state.is);
		}
	},
	
	/**
	 * 初期状態のDOMを生成して返す
	 * @returns $Object
	 */
	createDefaultElement() {
		let $elm;
		
		if(this.container.$replicantTemplate) {
			$elm = this.container.$replicantTemplate.clone().attr("id", null);
			
			if( this.container.module instanceof Klass("TyrellModule") ) {
				$elm.find("[data-echo-pn]").each((i, elm) => {
					this._replaceParamName( $(elm) );
				});
				
				$elm.find("[data-echo-pd]").each((i, elm) => {
					this._replaceParamData( false, $(elm) );
				});
				
				$elm.find("[data-echo-pd]").addClass("echoed-data");
			}
			
		} else {
			$elm = $("<var/>").attr("data-vuw", this.name);
		}
		
		return $elm.addClass("vuw-replicant").attr({
			"data-index": this.index,
			"data-is": this.state.is
		});
	},
	
	/**
	 * getReady時に最初に実行される関数
	 * @param {$Object} $self
	 * @param {$Object} $template
	 * @returns Promise
	 */
	onReadyFirst($self, $template) {
		if(!$template && this.container.$replicantTemplate) {
			this.$template = this.container.$replicantTemplate;
			$template = this.$template;
		}
		
		if( u_.isFunction(this._onReadyFirst) ) {
			return this._onReadyFirst($self, $template);
		}
	},
	
	// **** render ****
	render($elm, state) {
		const module = this.container.module;
		
		if( !$elm || !( module instanceof Klass("TyrellModule") ) ) {
			return false;
		}
		
		// 初期化
		this.imagePromiseList = [];
		
		if( u_.isObject(state.item) ) {
			state.is = "active";
			$elm;
			!!state.item.itemId && $elm.attr("data-id", state.item.itemId);
			
			// paramDataの置換
			const $pd = $elm.find("[data-echo-pd]");
			const pdLen = $pd.length;
			for(let i = 0; i < pdLen; i++) {
				const $target = $pd.eq(i);
				if( !this._replaceParamData(state.item, $target) ) {
					// 空データの場合はpnの方も削除
					$elm.find(`[data-echo-pn='${$target.data("echo-pd")}']`).remove();
				}
			}
			
			// paramNameの置換
			const $pn = $elm.find("[data-echo-pn]");
			const pnLen = $pn.length;
			for(let i = 0; i < pnLen; i++) {
				this._replaceParamName( $pn.eq(i) );
			}
			
			const paramKeys = Object.keys(module.config.dataParams);
			const pkLen = paramKeys.length;
			for(let i = 0; i < pkLen; i++) {
				const pk = paramKeys[i];
				const pi = module.config.dataParams[pk];
				if(pi.inpType === "flg") {
					const v = state.item[pk] ? "on" : "off";
					$elm.addClass(`${pk}-${v}`);
				}
			}
			
			if( u_.isFunction(this.container.initArticle) ) {
				// コンテナのinitArticleが指定されている場合は実行
				const res = this.container.initArticle(
					state.item,
					module.config,
					$elm,
					module,
					this
				);
				
				// falseが返ってきた場合はstate.isを"sleeping"に変更
				(res === false) && (state.is = "sleeping");
			}
			
			delete state.item;
			
		} else
		if(state.is === "sleeping") {
			$elm = this.createDefaultElement();
		} else {
			return false;
		}
		
		return $elm.addClass("vuw-replicant").attr({
			"data-index": this.index,
			"data-is": state.is
		});
	},
	
	async getImageLoadPromise() {
		return await Promise.all(this.imagePromiseList);
	}
});
